export default "/_nuxt/b73ecbcf34c83041f31ba1f9082f5af1.svg";